(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-slider"] && !Shopify.designMode) return;
  try {
    
  let elSliders = document.querySelectorAll('.glider');
  if (elSliders.length) {
    for(const s of elSliders) {
      if (s.classList.contains('draggable')) { continue }
      const glider = new Glider(s, {
        slidesToShow: 2,
        itemWidth: 200,
        draggable: true,
        dots: s.nextElementSibling,//'#dots', 
        arrows: false,
        duration: 1,
        scrollLock: true,
        responsive: [
          {
            // screens greater than >= 775px
            breakpoint: 775,
            settings: {
              // Set to `auto` and provide item width to adjust to viewport
              slidesToShow: 5,
              slidesToScroll: 1,
              itemWidth: 100,
              duration: 0.7,
            },
          },
          {
            // screens greater than >= 1024px
            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              itemWidth: 100,
              duration: 1,
            },
          },
        ],
      });
      sliderAuto(glider, 2000);
    }

    function sliderAuto(slider, miliseconds) {
      const slidesCount = slider.track.childElementCount;
      let slideTimeout = null;
      let nextIndex = 1;

      function slide() {
        slideTimeout = setTimeout(function () {
          if (nextIndex >= slidesCount) {
            nextIndex = 0;
          }
          slider.scrollItem(nextIndex++);
        }, miliseconds);
      }

      slider.ele.addEventListener('glider-animated', function () {
        window.clearInterval(slideTimeout);
        slide();
      });

      slide();
    }
    
  }
  // Autoplay
  //   let autoplay = setInterval(() => {
  //     if (glider.page < glider.slides.length - glider.opt.slidesToShow) {
  //       glider.scrollItem(glider.page + 1);
  //     } else {
  //       glider.scrollItem(0);
  //     }
  //   }, 2000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insider-coupon"] && !Shopify.designMode) return;
  try {
    
  
  var percent = 12;
  var var_type = "percent"
  
  const percentEl = document.querySelector("[data-coupon-value]");
  
  if (percentEl) {
    percent = parseInt(percentEl.getAttribute("data-coupon-value"));
    var_type = percentEl.getAttribute("data-coupon-type");
  }
  
  if (var_type == "percent") {
    // percent = Number(Number(percent).toFixed(2) * 100 * 1).toFixed(0);
    const priceListTags = document.getElementsByClassName("price-list");
    const salePriceTags = document.getElementsByTagName("sale-price");
    const couponElement = document.createElement("div");
    
    couponElement.innerText = `Extra ${percent}% off coupon`;
    couponElement.className = "coupon";
    
    const totalSalePriceElement = document.createElement("div");
    totalSalePriceElement.className = "total-sale-price";

    console.log(couponElement.innerText)
    
    for (let i = 0; i < priceListTags.length; i++) {
      
      const price = parseFloat(
        salePriceTags[i].innerText.replace(/[a-zA-Z$€\s]+/, "")
      );
      console.log(price)
      const totalSalePrice = price - (price * percent) / 100;
      totalSalePriceElement.innerHTML = `<span class="font-bold">$${totalSalePrice.toFixed(
        2
      )}</span> after coupon`;
      priceListTags[i].after(totalSalePriceElement.cloneNode(true));
      priceListTags[i].after(couponElement.cloneNode(true));
    }
    
  } else if (var_type == "fixed") {
    const priceListTags = document.getElementsByClassName("price-list");
    const salePriceTags = document.getElementsByTagName("sale-price");
    const couponElement = document.createElement("div");
    couponElement.innerText = `Extra $${percent} off coupon`;
    couponElement.className = "coupon";
    const totalSalePriceElement = document.createElement("div");
    totalSalePriceElement.className = "total-sale-price";
  
    for (let i = 0; i < priceListTags.length; i++) {
      const price = parseFloat(
        salePriceTags[i].innerText.replace(/[a-zA-Z€$\s]+/, "")
      );
      const totalSalePrice = price - percent;
      totalSalePriceElement.innerHTML = `<span class="font-bold">$${totalSalePrice.toFixed(
        2
      )}</span> after coupon`;
      priceListTags[i].after(totalSalePriceElement.cloneNode(true));
      priceListTags[i].after(couponElement.cloneNode(true));
    }
  }

  } catch(e) { console.error(e); }
})();
})();
